import { GetterTree, MutationTree, ActionTree, ActionContext, Module } from 'vuex';
import { RootState } from '../types';

export type State = {
  isComplete: boolean;
  isAutoCalled: boolean;
  isRedirected: boolean;
};

function createState(): State {
  const state: State = {} as State;
  clearState(state);
  return state;
}

function clearState(state: State): void {
  state.isComplete = false;
  state.isAutoCalled = false;
  state.isRedirected = false;
}

const getters: GetterTree<State, RootState> = {
  isComplete: (state: State): boolean => state.isComplete,
  isAutoCalled: (state: State): boolean => state.isAutoCalled,
  isRedirected: (state: State): boolean => state.isRedirected
};

const mutations: MutationTree<State> = {
  setComplete(state: State) {
    state.isComplete = true;
  },

  setAutoCalled(state: State, payload: boolean) {
    state.isAutoCalled = payload;
  },

  setRedirected(state: State, payload: boolean) {
    state.isRedirected = payload;
  },

  clearState(state: State) {
    clearState(state);
  }
};

const actions: ActionTree<State, RootState> = {
  clearState(context: ActionContext<State, RootState>): void {
    context.commit('clearState');
  }
};

const module: Module<State, RootState> = {
  namespaced: true,
  state: createState,
  getters,
  mutations,
  actions
};

export default module;
